var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListView = function SvgListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.965 3.501a1.965 1.965 0 1 0 0 3.93 1.965 1.965 0 0 0 0-3.93M4 5.466a.965.965 0 1 1 1.93 0 .965.965 0 0 1-1.93 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 6h12V5H9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.965 10.04a1.965 1.965 0 1 0 0 3.931 1.965 1.965 0 0 0 0-3.93M4 12.006a.965.965 0 1 1 1.93 0 .965.965 0 0 1-1.93 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 12.504h12v-1H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 18.536a1.965 1.965 0 1 1 3.93 0 1.965 1.965 0 0 1-3.93 0m1.965-.965a.965.965 0 1 0 0 1.93.965.965 0 0 0 0-1.93",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 19H9v-1h12z"
  })));
};
export default SvgListView;